import { ActionContext } from 'vuex';
import type { State } from './state';
import { MutationType } from './mutations';
import { profileApi } from '@/api/profile';
import type { UserProfile } from '@/types';

export enum ActionType {
    FetchProfile = 'FETCH_PROFILE',
    UpdateProfile = 'UPDATE_PROFILE',
    FetchLanguages = 'FETCH_LANGUAGES',
    SetLanguage = 'SET_LANGUAGE',
}

type Context = ActionContext<State, State>;

export type Actions = {
    [ActionType.FetchProfile](context: Context): Promise<void>;
    [ActionType.UpdateProfile](context: Context, payload: Partial<UserProfile>): Promise<void>;
    [ActionType.FetchLanguages](context: Context): Promise<void>;
    [ActionType.SetLanguage](context: Context, languageId: number): Promise<void>;
};

export const actions: Actions = {
    async [ActionType.FetchProfile]({ commit }) {
        const user = await profileApi.get();
        commit(MutationType.SetUser, user);
    },

    async [ActionType.UpdateProfile]({ commit }, payload) {
        const user = await profileApi.update(payload);
        commit(MutationType.SetUser, user);
    },

    async [ActionType.FetchLanguages]({ commit }) {
        const languages = await profileApi.getLanguages();
        commit(MutationType.SetLanguages, languages);
    },

    async [ActionType.SetLanguage]({ dispatch }, languageId) {
        await profileApi.setLanguage(languageId);
        await dispatch(ActionType.FetchProfile);
    },
};
